/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettlementDetailHeaderComponent} from './settlement-detail-header.component';
import {PipesModule} from '../../shared/pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        PipesModule
    ],
    declarations: [SettlementDetailHeaderComponent],
    exports: [SettlementDetailHeaderComponent]
})

export class SettlementDetailHeaderComponentModule {
}
